import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CrmStaticPage, CrmStaticPages } from '@core/models';
import { API_LIST } from '@core/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrmService {
  private httpClient = inject(HttpClient);

  checkCrmStaticPages(): Observable<CrmStaticPages> {
    return this.httpClient.get<CrmStaticPages>(API_LIST.checkCrmStaticPages());
  }

  getCrmStaticPage(slug: string): Observable<CrmStaticPage> {
    return this.httpClient.get<CrmStaticPage>(API_LIST.getCrmStaticPage(slug));
  }
}
